export default "__VITE_ASSET__3adfe0b3__"